import * as React from 'react';
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { ILoginViewModel } from '../../types/ILoginViewModel';
import { Redirect } from 'react-router-dom';
import { If } from '../../../core/components/If';
import { AAD_LOGIN_TYPE } from '../../Consts';
import { attachMatchingEngineMsalInterceptor } from "../../../setupAxios";


interface IMSALAuthenticatedProps {
    login: (viewModel: ILoginViewModel, redirect: any) => void;
    redirect?: any;
    isSignedIn: boolean;
}

export const MSALAuthenticated = ({ login, redirect, isSignedIn }: IMSALAuthenticatedProps) => {
    const { instance, accounts } = useMsal();
    const account = accounts[0]

    useEffect(() => {

        const username = account.username;

        let vm: ILoginViewModel = {
            email: username,
            password: null,
            rememberMe: true,
            loginType: AAD_LOGIN_TYPE,
            username: username
        }


        attachMatchingEngineMsalInterceptor(instance, account);
        login(vm, redirect);
    }, []);

    return (
        <If condition={isSignedIn}>
            <Redirect to={'/'} />
        </If>
    );
}